/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SnapDetailsLineItem } from './SnapDetailsLineItem';
import type { SnapState } from './SnapState';

export type SnapDetails = {
    submitTimestamp: string;
    collectorId: string;
    imageUrl: string;
    merchant: string;
    receiptTimestamp: string;
    hasFlippedDayAndYear: boolean;
    receiptTimestampScore?: number;
    receiptTimestampOcrScore?: number;
    subtotal: number;
    subtotalScore?: number;
    subtotalOcrScore?: number;
    totalTax?: number;
    totalTaxScore?: number;
    totalTaxOcrScore?: number;
    total: number;
    totalScore?: number;
    totalOcrScore?: number;
    state: SnapState;
    lineItems: Array<SnapDetailsLineItem>;
    lineItemsCreationAllowed?: boolean;
    requiresTroubleshooting?: boolean;
    duplicateOf?: number;
    duplicates?: Array<number>;
    processingByOpsUserId?: number;
    processingByOpsUserEmail?: string;
    processingByOpsUserRole?: string;
    processingByOpsUserIdStartedAt?: string;
    isEscalated?: boolean;
    isMarkedAsDone?: boolean;
    claimDetails?: string;
    claimReferenceCode?: string;
    escalateDetails?: string;
    collectorRegion?: SnapDetails.collectorRegion;
    platform?: string;
    locale?: string;
    referenceCode?: string;
    hasDirtyTransactions?: boolean;
    hasConflictedMatches?: boolean;
    canHaveOfferMatches: boolean;
    externalId?: number;
    isCollectorFraudster?: boolean;
    isFraudSuspicious?: boolean;
    fraudSuspicionReason?: string;
    isReprocessingAllowed?: boolean;
    isCompleteProcessingAllowed?: boolean;
    enabledBaseIssuanceRetailer?: boolean;
    nextSnapAllowed?: boolean;
    nextSnapVisible?: boolean;
};

export namespace SnapDetails {

    export enum collectorRegion {
        AB = 'AB',
        BC = 'BC',
        MB = 'MB',
        NB = 'NB',
        NL = 'NL',
        NT = 'NT',
        NS = 'NS',
        NU = 'NU',
        ON = 'ON',
        TB = 'TB',
        PE = 'PE',
        QC = 'QC',
        SK = 'SK',
        YT = 'YT',
    }


}

